import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataDecimal,
  ODataBoolean,
  ODataDateTime,
  ODataInteger
} from "pbas-vue-components";

const headers = [
  new ODataHeader({
    type: new ODataString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.eligibility_bank.calendar_year",
    type: new ODataInteger("CalendarYear"),
    sortable: true,
    visible: true,
    searchable: true,
    subHeaders: [new ODataHeader({
      title: "headers.eligibility_bank.calendar_month",
      type: new ODataInteger("CalendarMonth"),
      sortable: true,
      visible: false,
      allowVisibilityChange: false,
    })]
  }),
  new ODataHeader({
    title: "headers.eligibility_bank.calendar_month",
    type: new ODataInteger("CalendarMonth"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.eligibility_bank.hours_worked",
    type: new ODataDecimal("HoursWorked", {
      getString: (item, type) => {
        const value = item.HoursWorked;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.eligibility_bank.hours_deducted",
    type: new ODataDecimal("HoursDeducted", {
      getString: (item, type) => {
        const value = item.HoursDeducted;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.plan_balance.current_balance",
    type: new ODataDecimal("Balance", {
      getString: (item, type) => {
        const value = item.Balance;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.eligibility_bank.excess",
    type: new ODataDecimal("ExcessHours", {
      getString: (item, type) => {
        const value = item.ExcessHours;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  //has self payment checkbox
  new ODataHeader({
    title: "headers.eligibility_bank.has_self_payment",
    type: new ODataBoolean("HasSelfPayment"),
    sortable: false,
    visible: true,
    searchable: false,
    version: 2
  }),
];
export default headers;
